import { styled } from "@mui/material";

export const StyledUnsupportedBrowser = {
  Center: styled("div")({
    flex: 1,
    display: "flex",
    justifyContent: "center",
  }),

  Root: styled("div")({
    display: "flex",
    flexDirection: "column",
    fontFamily: "Roboto, sans-serif",
    fontSize: "x-large",
    alignSelf: "center",
    alignItems: "center",
    textAlign: "center",
  }),

  Browser: styled("div")({
    color: "#303030",
    fontSize: "medium",
    marginRight: 20,
  }),

  Container: styled("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  }),

  Link: styled("a")({
    color: "blue",
  }),
};
export const StyledUnsupportedVersionBrowser = {
  Center: styled("div")({
    flex: 1,
    display: "flex",
    justifyContent: "center",
  }),

  Root: styled("div")({
    display: "flex",
    flexDirection: "column",
    fontFamily: "Roboto, sans-serif",
    fontSize: "x-large",
    alignSelf: "center",
    alignItems: "center",
    textAlign: "center",
  }),

  Browser: styled("div")({
    color: "#303030",
    fontSize: "medium",
    marginRight: 20,
  }),

  VersionContainer: styled("div")({
    fontSize: 12,
  }),

  BrowserVersion: styled("span")({
    color: "red",
  }),

  BrowserMinVersion: styled("span")({
    color: "green",
  }),

  Container: styled("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  }),

  Link: styled("a")({
    fontWeight: "500",
    color: "blue",
  }),
};
